// extracted by mini-css-extract-plugin
export default {"selected":"Totals_selected__12lTP","deselected":"Totals_deselected__5BID8","cutoff":"Totals_cutoff__1taZe","select":"Totals_select__MwgXQ"};